import Lenis from "lenis";

let lenis = null;

export function initLenis() {
  lenis = new Lenis({ duration: 1.15, smoothWheel: true });
  let raf;
  const loop = (time) => {
    lenis.raf(time);
    raf = requestAnimationFrame(loop);
  };
  raf = requestAnimationFrame(loop);
  return () => {
    cancelAnimationFrame(raf);
    lenis?.destroy();
    lenis = null;
  };
}

export function scrollToSection(selector) {
  if (lenis) {
    lenis.scrollTo(selector, { offset: -64, duration: 1.5 });
  } else {
    document.querySelector(selector)?.scrollIntoView({ behavior: "smooth" });
  }
}
